import { Tool, type ToolArgsWithController } from '@aha-app/aha-editor-v2';
import {
  embedWhiteboard,
  insertWhiteboard,
} from 'components/aha_editor_field_v2/WhiteboardUtils';
import chooseExistingWhiteboard from '../components/ExistingWhiteboardPickerModal';

class ToolInsertExistingWhiteboard extends Tool {
  static toolName = 'Existing whiteboard';
  static iconClass = 'fa-regular fa-shapes';

  static available({ controller }: ToolArgsWithController): boolean {
    return Boolean(controller.ahaEditor.hasPlugin('embeddedWhiteboard'));
  }

  static action({ editor, controller }: ToolArgsWithController) {
    insertWhiteboard(
      { editor },
      chooseExistingWhiteboard().then(whiteboardId => {
        if (whiteboardId) {
          return embedWhiteboard({
            objectId: controller.objectId,
            objectType: controller.objectType,
            whiteboardId,
            baseURL: controller.baseURL,
            getSharingToken: controller.getSharingToken,
          });
        }
      })
    );
  }
}

export default ToolInsertExistingWhiteboard;
